/* Static config for the Account Monitoring page.
 * Wire contract lives in .claude/specs/account-monitoring-frontend-spec.md §3-§5.
 */

// `Can send` badge map. `tone` selects an `.am-badge-<tone>` pill in the stylesheet.
export const SEND_STATUS = {
  ok: { tone: 'success', label: 'can send' },
  rate_limited: { tone: 'danger', label: 'rate limited' },
  disconnected: { tone: 'danger', label: 'disconnected' },
}

// Fallback tone for a `send.level` the frontend does not know yet — a new backend state
// then degrades to a visible neutral badge showing the raw level, rather than vanishing.
export const UNKNOWN_LEVEL_TONE = 'secondary'

// Days requested from /daily when a row is expanded.
export const DAILY_DAYS = 7

// Column header tooltips.
//
// The `sentYesterday` wording is load-bearing. The backend cannot express a trailing
// 24-48h window — IMAP search compares dates, not timestamps — so once a period is fully
// past, the only expressible bucket is a whole UTC calendar day. The column is therefore
// labelled "Prev. UTC day" and never "24-48h": that label on a calendar-day number is
// something people make decisions on and get wrong.
export const COLUMN_TOOLTIPS = {
  sentToday: 'Sent in the last 24 hours (rolling, not a UTC calendar day)',
  sentYesterday: 'Sent during the previous full UTC day',
  sent: 'Lifetime total in the mailbox\'s Sent folder',
  inbox: 'Lifetime message count in the Inbox folder',
  unseen: 'Unread messages in the Inbox folder',
  remainingToday: 'Sends left today against the account\'s daily cap, per cocloud\'s own rate limiter',
}

export const EMPTY_MESSAGE = 'No mailboxes registered in EmailEngine.'
